<template>
    <div class="ma-3">
        <div layout="column" layout-align="center center">
            <div layout="column" class="field-width">
                <div>
                    <v-btn flat class="mt-3"
                        :to="{ name: 'admin-sessions-teams-show-exceptions-edit', params: { exception_id: 'new' } }">
                        <v-icon left color="primary">
                            mdi-plus-box
                        </v-icon>
                        Add a new exception
                    </v-btn>
                </div>

                <v-data-table :headers="headers" :items="exceptions" style="max-width: 1000px"
                    :pagination.sync="pagination">
                    <template slot="items" slot-scope="{ item }">
                        <td>{{ formatDate(item.start) }}</td>
                        <td>{{ formatDate(item.end) }}</td>
                        <td>{{ item.max_morning }}</td>
                        <td>{{ item.max_afternoon }}</td>
                        <td>{{ item.max_evening }}</td>
                        <td layout="row">
                            <v-btn class="mx-0" icon
                                :to="{ name: 'admin-sessions-teams-show-exceptions-edit', params: { exception_id: item.id } }">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <delete-button :label="'the exception ' + formatDate(item.start) + ' to ' + formatDate(item.end)"
                                @confirm="deleteImpl(item)" />
                        </td>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import Params from '@/api/params'
import GlobalMixin from '@/mixins/global'
import Consts from '@/consts'
import DeleteButton from "@/components/shared/DeleteButton.vue"
import DateMixin from '@/mixins/date'

export default {
    components: { DeleteButton },
    mixins: [GlobalMixin, DateMixin],
    props: {
        team: {
            type: Object,
            required: true,
            default: () => { }
        }
    },
    data() {
        return {
            pagination: {
                rowsPerPage: 10,
                sortBy: 'start',
                descending: 1
            },
            headers: [
                { text: 'Start', value: 'start' },
                { text: 'End', value: 'end' },
                { text: 'Morning', value: 'max_morning' },
                { text: 'Afternoon', value: 'max_afternoon' },
                { text: 'Evening', value: 'max_evening' },
                { text: 'Actions', sortable: false, width: "80px" }
            ],
            exceptions: [],
            Consts
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            Params.getList(`teams/${this.team.id}/capacity-exceptions`).then(res => {
                this.exceptions = res.data
            })
        },
        deleteImpl (item) {
            Params.delete('teams/' + this.team.id + '/capacity-exceptions', item.id).then(() => {
                this.fetch()
                this.$snotify.success(`The exception has been deleted`)
            })
        },
    }
}
</script>
